<head>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" rel="stylesheet">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">
</head>

<div class="fixed-submenus">
<!--contenedor fijo 1 ini-->
<div class="web">
  <div class="topLogoContainer">
    <div class="topLogoCenter">
        <div class="container-fluid" style="padding: 0;">
          <div class="row" style="margin: 0;">
            <!-- Redes sociales -->
            <div class="col-sm-3 flex-left-icon">
              <a href="https://www.facebook.com/diariooficialelperuano" target="_blank">
                <i class="bi bi-facebook social-icon"></i>
              </a>
              <a href="https://x.com/DiarioElPeruano" target="_blank">
                <i class="bi bi-twitter-x social-icon"></i>
              </a>
              <a href="https://www.instagram.com/diarioelperuano/" target="_blank">
                <i class="bi bi-instagram social-icon"></i>
              </a>
              <a href="https://pe.linkedin.com/company/elperuano" target="_blank">
                <i class="bi bi-linkedin social-icon"></i>
              </a>
              
            </div>
            
            <!-- Imagen centrada -->
            <div class="col-sm-6 flex-center-img-editora">
              <a [routerLink]="['/']">
                <img src="/assets/image/elperuano_logo_201.png" alt="Diario Oficial El Peruano" class="imagen-h-elperuano" />
              </a>  
            </div>
          
            <!-- Carrito -->
            <div class="col-sm-3 flex-right-carrito">
              <div class="nav-item dropdown" ngDropdown>
                <a type="button" ngDropdownControl (click)="actualizarCarrito()" class="nav-link waves-light" mdbWavesEffect style="padding-left: 0.5rem;padding-right: 0.5rem;">
                  Carrito({{cantidadCarrito}}) <img src="/assets/image/header/h3.png" width="20px" />
                </a>
                <div ngDropdownContent class="dropdown-menu dropdown-primary redIn divMenuRegalos" dropdownClass="slide-fade">
                  <app-carrito-compras-header [flagActualizar]="flagActualizar" (itemEliminado)="onItemEliminado()"></app-carrito-compras-header>
                </div>
              </div>
              <span class="raya_vertical"></span>
              <div class="nav-item dropdown" ngDropdown>
                <a id="modallogin1" mdbWavesEffect type="button" ngDropdownControl class="nav-link waves-light" style="padding-left: 0.5rem;padding-right: 0.5rem;">
                  <span *ngIf="!obtenerSesion()" style="padding-right: 0.5rem;"> Ingrese</span>
                  <span *ngIf="obtenerSesion()"> Mi cuenta</span>
                  <span class="caret"></span>
                  <img src="/assets/image/header/h2.png" width="15px" />
                </a>
                <div id="modallogin" #modallogin ngDropdownContent class="dropdown-menu dropdown-primary">
                  <app-login (newItemEvent)="closeItem()"></app-login>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </div>      
</div>
<!--contenedor fijo 1 fin-->
<!--contenedor fijo 2 ini-->
<div class="web">
    <div class="topMenuBusquedaContainer">
      <div class="topMenuBusquedaCenter">
            <!--div class="container-fluid" style="padding-top: 0; margin-top: 0;"-->
            <div class="container-fluid">
              <!--div class="row d-flex align-items-center" style="margin-top: 0; padding-top: 0;"-->
              <div class="row d-flex align-items-center">
                <div class="mr-1">
                  <table class="topMenuTable">
                    <tr class="topMenuTR">
                      <td [ngClass]="{'selected-option': selectedOption === '1'}" 
                          (click)="selectOption('1'); visibilidad('#subMenuFotografia'); buscarConsulta('1','')">Fotografías</td>
                      <td [ngClass]="{'selected-option': selectedOption === '2'}" 
                          (click)="selectOption('2'); visibilidad('#subMenuPortada'); buscarConsulta('2','')">Portadas Históricas</td>
                      <td [ngClass]="{'selected-option': selectedOption === '3'}" 
                          (click)="selectOption('3'); visibilidad('#subMenuHemeroteca'); buscarConsulta('3','')">Hemeroteca</td>
                    </tr>
                  </table>
                </div>
                <div>
                  <div class="input-group" style="height: 33px; width: 100%;">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="padding-left: 5px; padding-right: 5px;">
                        <i class="fas fa-search" style="font-size: 1rem;"></i>
                      </span>
                    </div>
                    <input type="text" id="defaultLoginFormEmail" [(ngModel)]="txtBusqueda" (keyup.enter)="buscar()" 
                           class="form-control" placeholder="Búsqueda general, categoría, título, autor" 
                           style="height: 33px; font-size: 1rem; max-width: 160px;">
                  </div>
                </div>
                <ng-container *ngIf="!isFechaEnable">
                  <div class="d-flex align-items-center" style="margin-top: 0;">
                    <!-- Fecha Inicio -->
                    <label for="txtFechaIni" class="spacing-label-fecha">Fecha Inicio</label>
                    <input type="date" id="txtFechaIni" [value]="fechaIniLoad" maxlength="10" [(ngModel)]="txtFechaIni" class="form-control fecha-home" mdbInput style="width: 100px; height: 33px; padding: 2px 1px; line-height: 1.5;">
                    <!-- Fecha Fin -->
                    <label for="txtFechaFin" class="spacing-label-fecha">Fecha Fin</label>
                    <input type="date" id="txtFechaFin" [(ngModel)]="txtFechaFin" maxlength="10" class="form-control fecha-home" mdbInput style="width: 100px; height: 33px; padding: 2px 1px; line-height: 1.5;">
                  </div>
                </ng-container>
                <div>
                  <!-- Botón-->
                  <div style="margin-top: 0;">
                    <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar('buscar')" class="btn btn-red btn-rounded btn-sm" style="padding-left:5px;padding-right:5px;" mdbWavesEffect>
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
            </div>

      </div>
    </div>    
</div>
<!--contenedor fijo 2 fin-->
<!--contenedor fijo 3 ini-->

<div class="web">
  <div class="topSubMenuContainer">
    <div class="topSubMenuCenter">
        <div class="container-fluid" id="subMenuFotografia" visible="true" style="padding: 0;">
          <div class="row" style="margin: 0;"> 
            <div class="col-sm-12" style="padding: 0;">
              <table class="w-100">
                <tr class="topSubMenuTR d-flex justify-content-center">
                  <td><a (click)="buscarConsulta('1','1')" >Cultura1</a></td>
                  <td><a (click)="buscarConsulta('1','2')" >Política</a></td>
                  <td><a (click)="buscarConsulta('1','3')">Deportes</a></td>
                  <td><a (click)="buscarConsulta('1','4')">Espectáculos</a></td>
                  <td><a (click)="buscarConsulta('1','11')">Regiones</a></td>
                  <td><a (click)="buscarConsulta('1','12')">Economía</a></td>
                  <td><a (click)="buscarConsulta('1','13')">Sociedad</a></td>
                  <td><a (click)="buscarConsulta('1','14')">Presidentes</a></td>
                </tr>
              </table>
            </div>
          </div>
        </div> 
        <div class="container-fluid" id="subMenuPortada" style="display: none; padding: 0;">  
          <div class="row" style="margin: 0;">
            <div class="col-sm-12" style="padding: 0;">
              <table class="w-100">
                <tr class="topSubMenuTR d-flex justify-content-center">
                  <td><a (click)="buscarConsulta('2','5')">Portadas Siglo XIX</a></td>
                  <td><a (click)="buscarConsulta('2','6')">Portadas Siglo XX</a></td>
                  <td><a (click)="buscarConsulta('2','7')">Portadas Siglo XXI</a></td>
                  <td><a (click)="buscarConsulta('2','8')">Centrales históricos</a></td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="container-fluid" id="subMenuHemeroteca" style="display: none; padding: 0;">  
          <div class="row" style="margin: 0;">  
             <div class="col-sm-12" style="padding: 0;">
              <table class="w-100">
                <tr class="topSubMenuTR d-flex justify-content-center">
                  <td><a >Información desde 1825 a 1951</a></td>
                </tr>
              </table>
             </div>
          </div>
        </div>

        
    </div>
  </div>
</div>
<!--contenedor fijo 3 fin-->


<!--contenedor fijo 1 ini-->
<div class="movil">
  <div class="topLogoContainerM">
    <div class="topLogoCenterM">
      <div class="container-fluid" style="width:100%;padding: 0;">
        <div class="row" style="margin: 0; width: 100%;"> 
          <div class="col-1"></div>
          <div class="col-5" style="display: flex; justify-content: center; align-items: center; padding: 1rem 0; margin: 0;">
            <a [routerLink]="['/']">
              <img src="/assets/image/elperuano_logo_201.png" alt="Diario Oficial El Peruano" class="imagen-h-elperuano" />
            </a>  
          </div>
          <div class="col-6" style="display: flex; justify-content: flex-end; align-items: center; padding: 1rem 0; margin: 0;">
            <div class="nav-item dropdown" ngDropdown>
              <a type="button" ngDropdownControl (click)="actualizarCarrito()" class="nav-link waves-light" mdbWavesEffect style="padding-left: 0.5rem;padding-right: 0.5rem;">
                ({{cantidadCarrito}}) <img src="/assets/image/header/h3.png" width="20px" />
              </a>
              <div ngDropdownContent class="dropdown-menu dropdown-primary redIn divMenuRegalos" dropdownClass="slide-fade">
                <app-carrito-compras-header [flagActualizar]="flagActualizar" (itemEliminado)="onItemEliminado()"></app-carrito-compras-header>
              </div>
            </div>
            <div class="nav-item dropdown" ngDropdown>
              <a id="modallogin1" mdbWavesEffect type="button" ngDropdownControl class="nav-link waves-light" style="padding-left: 0.5rem;padding-right: 0.5rem;">
                <span *ngIf="!obtenerSesion()" style="padding-right: 0.5rem;"> </span>
                <span *ngIf="obtenerSesion()"> Mi cuenta</span>
                <span class="caret"></span>
                <img src="/assets/image/header/h2.png" width="15px" />
              </a>
              <div id="modallogin" #modallogin ngDropdownContent class="dropdown-menu dropdown-primary">
                <app-login (newItemEvent)="closeItem()"></app-login>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

<!--contenedor fijo 2 ini-->
<div class="movil">
  
  
  <div class="topMenuBusquedaContainerM">
    <div class="topMenuBusquedaCenterM">
      <div class="container-fluid" style="width:100%;padding: 0;">
        <div class="row d-flex align-items-center" style="margin: 0; width: 100%;"> 
          
          <!-- Menú Hamburguesa -->
          <nav class="navbar navbar-expand-lg navbar-light" style="padding: 0.10rem;margin-right: 10px;">
            <button class="navbar-toggler" type="button" (click)="toggleMenu()" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <!--div [ngbCollapse]="isMenuCollapsed" class="navbar-collapse"-->
            <div [ngbCollapse]="isMenuCollapsed" class="navbar-collapse" style="z-index: 1000;">  
              <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                  <a class="nav-link" href="#">Inicio</a>
                </li>
                <li class="nav-item has-submenu" [ngClass]="{ 'active': isCulturalMenuOpen }">
                  <a class="nav-link" (click)="toggleCulturalMenu()">Fotografías</a>
                  <ul *ngIf="isCulturalMenuOpen" class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','1')">Cultural</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','2')">Política</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','3')">Costumbres</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','4')">Turismo</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Arte</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Espectáculo</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Deporte</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Literatura</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','14')">Presidentes</a>
                    </li>
                  </ul>
                </li>        
                <li class="nav-item has-submenu" [ngClass]="{ 'active': isPortadasMenuOpen }">
                  <a class="nav-link" (click)="togglePortadaMenu()">Portadas</a>
                  <ul *ngIf="isPortadasMenuOpen" class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','5')">Siglo XVIII</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','5')">Siglo XIX</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','6')">Siglo XX</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','7')">Siglo XXI</a>
                    </li>
                  </ul>
                </li>          
                <li class="nav-item">
                  <a class="nav-link" href="#">Hemeroteca</a>
                </li>
              </ul>
            </div>
          </nav>
          <div>
            <div class="input-group" style="height: 22px; width: 100%; display: flex; align-items: center; margin-right: 10px;">
              <div class="input-group-prepend" style="display: flex; align-items: center;">
                <span class="input-group-text" style="height: 22px; display: flex; align-items: center;padding-left: 5px; padding-right: 5px;padding-top: 2px;padding-bottom: 2px;">
                  <i class="fas fa-search" style="font-size: 1rem;"></i>
                </span>
              </div>
              <input type="text" id="defaultLoginFormEmail" [(ngModel)]="txtBusqueda" (keyup.enter)="buscar()" 
                     class="form-control" placeholder="Búsqueda general, categoría, título, autor" 
                     style="height: 22px; font-size: 1rem; width: 100%; max-width: 210px;">
            </div>
          </div>
          <div style="display: flex;justify-content: center;align-items: center; ">

            <!--mat-form-field style="display: flex; justify-content: center; align-items: center; padding: 0; position: relative;">
              <mat-label></mat-label>
              <mat-date-range-input [rangePicker]="picker" style="visibility: hidden; display: none;" (dateChange)="onDateChange($event)">
                <input matStartDate [(ngModel)]="selectedDateRange.begin" placeholder="Start date" (dateChange)="dateChanged('start', $event)" [min]="minDate" [max]="maxDate" style="margin-right: 10px;">
                <input matEndDate [(ngModel)]="selectedDateRange.end" placeholder="End date" (dateChange)="dateChanged('end', $event)" [min]="minDate" [max]="maxDate" style="margin-left: 10px;">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker" style="display: flex; justify-content: center; align-items: center; padding: 5px; position: relative; z-index: 10;">
                <mat-icon matDatepickerToggleIcon>
                  <img src="/assets/image/calendario.jpg" alt="Calendar Icon" style="width: 20px; height: 20px;">
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-date-range-picker #picker [startAt]="startDate" style="position: absolute; top: 50px; left: 0; z-index: 100;">
              </mat-date-range-picker>
              <button mat-icon-button (click)="clearDates()">
                clear
              </button>
            </mat-form-field-->
            

            <mat-form-field style="display: flex;justify-content: center;align-items: center; padding: 0;">
              <mat-label></mat-label>
              <mat-date-range-input [rangePicker]="picker" style="visibility: hidden;display: none;padding:0;"  (dateChange)="onDateChange($event)" >
                <input matStartDate [(ngModel)]="selectedDateRange.begin"  placeholder="Start date" (dateChange)="dateChanged('start', $event)" [min]="minDate" [max]="maxDate" >
                <input matEndDate [(ngModel)]="selectedDateRange.end" placeholder="End date" (dateChange)="dateChanged('end', $event)" [min]="minDate" [max]="maxDate" >
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker" style="display: flex;justify-content: center;align-items: center; padding: 0;">
                <mat-icon matDatepickerToggleIcon style="display: flex;justify-content: center;align-items: center;">
                  <img src="/assets/image/calendario.jpg" alt="Calendar Icon" style="width: 20px; height: 20px; padding-top: 0px;text-decoration: none;">
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-date-range-picker #picker [startAt]="startDate">
              </mat-date-range-picker>
              <button mat-icon-button (click)="clearDates()">
                clear
              </button>
            </mat-form-field>
          </div>
        </div>
     </div>

    </div>
  </div>
</div>    
<!--contenedor fijo 2 fin-->
<!--contenedor fijo 3 ini-->
<div class="movil">
  <div class="topSubMenuContainerM">
    <div class="topSubMenuCenterM">
        <div class="container-fluid" id="subMenuFotografia" visible="false" style="width:100%;padding: 0;color: #fff !important;">
          <div class="row" style="margin: 0; width: 100%;"> 
            <div class="col-sm-12" style="padding: 0; margin: 0;">
              <table class="w-100" style="padding: 0px; margin: 0px;">
                <tr style="padding: 0px; margin: 0px;" class="menuSubHeader d-flex justify-content-center custom-bg-plomo">  
                  <td style="padding: 3px!important;margin-right: 10px;">
                    <a (click)="selectOption('1'); visibilidad('#subMenuFotografia'); buscarConsulta('1','')">
                      Fotografías
                    </a>
                  </td>
                  <td style="padding:3px!important;margin-right: 10px;"><a (click)="selectOption('2'); visibilidad('#subMenuPortada'); buscarConsulta('2','')">Portadas Históricas</a></td>
                  <td style="padding:3px!important;margin:0px!important;"><a (click)="selectOption('3'); visibilidad('#subMenuHemeroteca'); buscarConsulta('3','')">Hemeroteca</a></td>
                </tr>
              </table>
            </div>
          </div>
        </div> 
      
    </div>
  </div>
</div>
<!--contenedor fijo 3 fin-->

</div> <!-- div fijo-->



<!--p>{{ selectedDateRange?.begin | date }} - {{ selectedDateRange?.end | date }}</p-->

<!--button mat-button (click)="clearDates()">Limpiar</button-->
